
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import * as Pedidos from '@lib/Ventas/Pedidos';
    import cliente from './editar-cliente.vue';
    import envio from './editar-envio.vue';
    import items from './editar-items.vue';
    import pagos from './editar-pagos.vue';
    import barra from './barra-lateral.vue';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            cliente,
            envio,
            items,
            pagos,
            barra,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get EdicionPedido() { return this.Controlador.EdicionPedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Pedido() { return this.Controlador.Pedido; }
        public get IniciadoPlataforma() { return this.Controlador.EdicionPedido.IniciadoPlataforma; }
        public Tipos: Pedidos.Tipos[] = [];
        public tipoSeleccionado: string = null;
        public get TipoSeleccionado()
        {
            return this.tipoSeleccionado;
        }
        public set TipoSeleccionado( x: string )
        {
            this.tipoSeleccionado = x;
            if ( !Pedidos.Tipos.toTipo( this.TipoSeleccionado ).esNoEspecificado )
            {
                this.EdicionPedido.Tipo = Pedidos.Tipos.toTipo( this.TipoSeleccionado );
                this.Paneles = [0, 1, 2];
            }
        }
        public Paneles: number[] = [0, 1, 2];
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {
            this.Eventos.push( Utiles.onKeyDown.subscribe( ( x ) => this.KeyDown( x ) ) );
            this.Eventos.push( Utiles.onKeyUp.subscribe( ( x ) => this.KeyUp( x ) ) );
            this.Tipos = Pedidos.Tipos.Plataformas;
            this.Eventos.push( this.Controlador.EdicionPedido.onTipo.subscribe( () =>
            {
                this.tipoSeleccionado = this.Controlador.EdicionPedido.Tipo.Id;
                this.Refrescar();
            } ) );
        }
        public Refresh: boolean = true;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
        KeyDown( e: KeyboardEvent )
        {
            if ( ['Enter'].includes( e.key ) && e.altKey )
            {
                e.preventDefault();
            }
        }
        async KeyUp( e: KeyboardEvent )
        {

            if ( ['Enter'].includes( e.key ) && e.altKey )
            {
                if ( this.EdicionPedido.GuardarYContinuar )
                    this.GuardarYContinuar();
                else
                    this.Guardar();
            }
        }


        async Cancelar()
        {
            if ( await Utiles.Mensajes.SiNo( 'Cancelar', '¿Cancelar este pedido?' ) )
            {
                await this.Controlador.Reiniciar();
                this.TipoSeleccionado = '';
                Utiles.Notificaciones.Info( 'Pedido cancelado' );
            }
        }
        async Reiniciar()
        {
            Utiles.setQuery( {} );
            await this.Controlador.Reiniciar();
            this.TipoSeleccionado = '';
        }

        async IrAlListado()
        {
            this.$router.push( '/pedidos?tipo=' + this.EdicionPedido.Tipo.Id );
        }

        async Guardar()
        {
            let errores = await this.Controlador.EdicionPedido.ComprobarErrores();
            if ( errores.hasRows() )
            {
                Utiles.Mensajes.Aceptar( 'Se encontraron errores', errores.map( x => `<li>${x}</li>` ).join( `\n` ) );
                return;
            }

            if ( await Utiles.Mensajes.SiNo( 'Guardar', '¿Guardar el pedido?' ) )
            {



                let e =  await this.Controlador.Guardar();
                if ( e )
                {
                    Utiles.Notificaciones.Completado( 'Guardado correctamente' );
                    await Wait( 300 );
                    await this.Controlador.Reiniciar();
                    this.TipoSeleccionado = '';
                } else
                {
                    Utiles.Notificaciones.Error( 'Error al guardar el pedido' );
                }
            }
        }
        async Omitir()
        {
            if ( await Utiles.Mensajes.SiNo( 'Omitir', '¿Omitir este pedido y pasar al siguiente?' ) )
            {
                Utiles.Notificaciones.Info( 'Pedido omitido' );
                await this.Controlador.SiguientePedido();
            }
        }
        async GuardarYContinuar()
        {

            let errores = await this.Controlador.EdicionPedido.ComprobarErrores();
            if ( errores.hasRows() )
            {
                Utiles.Mensajes.Aceptar( 'Se encontraron errores', errores.map(x=> `<li>${x}</li>`).join( `\n` ) );
                return;
            }

            if ( await Utiles.Mensajes.SiNo( 'Guardar', '¿Guardar el pedido?' ) )
            {
                let e = await this.Controlador.Guardar();
                if ( e )
                {
                    Utiles.Notificaciones.Completado( 'Guardado correctamente' );
                    await Wait( 300 );
                    await this.Controlador.SiguientePedido();
                } else
                {
                    Utiles.Notificaciones.Error( 'Error al guardar el pedido' );
                }
            }
        }

        async Abrir()
        {
            if ( await Utiles.Mensajes.SiNo( 'Abrir pedido', '¿Abrir detalle del pedido? Se perderán los cambios no guardados' ) )
            {
                this.$router.push( '/pedido/' + this.Controlador.Pedido.Id );
            }

        }
    }
